import { Typography } from "@mui/material"
import { navigate } from "lib/routes/navigate"

export function SkillMapRateCardLink({ item }) {
    return (
        <Typography
            variant="body2"
            sx={{
                px: 1.5,
                py: 0.75,
                borderRadius: 0.5,
                cursor: "pointer",
                "&:hover": { bgcolor: "action.hover" },
            }}
            onClick={handleClick}
        >
            {item.name}
        </Typography>
    )

    function handleClick(e) {
        e.stopPropagation()
        navigate(`/app/optimiser/rate-cards/${item.id}`)
    }
}
